import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'church',
      d: 'M-3,-4h1v0.5h-1zM-3,-3.5h2v0.5h-2zM-3,-3h2.5v0.5h-2.5zM-3,-2.5h1v0.5h-1zM-1,-2.5h1v4h-1zM-3,-2h0.5v2.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M1,-12h1v0.5h-1zM1,-9.5h1v0.5h-1zM2,-8h0.5v0.5h-0.5zM-1.5,-7.5h0.5v0.5h-0.5zM-2.5,-7h1v0.5h-1zM-1,-6h0.5v0.5h-0.5zM-2.5,-5.5h0.5v0.5h-0.5zM-3.5,-5h0.5v0.5h-0.5zM-3.5,-4.5h1v0.5h-1zM-0.5,-4.5h0.5v0.5h-0.5zM2.5,-4.5h0.5v0.5h-0.5zM1.5,-4h1.5v0.5h-1.5zM0.5,-3.5h2.5v0.5h-2.5zM-0.5,-3h2.5v0.5h-2.5zM2.5,-3h0.5v2h-0.5zM0,-2.5h1v0.5h-1zM1.5,-2.5h0.5v1.5h-0.5zM-2.5,-2h0.5v2.5h-0.5zM0,-2h0.5v1.5h-0.5zM1,-1h2v0.5h-2zM0,-0.5h3v0.5h-3zM0,0h2.5v0.5h-2.5zM0,0.5h1.5v0.5h-1.5zM0,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofA',
      d: 'M-1.5,-7h0.5v0.5h-0.5zM-2,-6.5h1v1h-1zM-1.5,-5.5h1v0.5h-1zM-2.5,-5h0.5v1h-0.5zM-1,-5h0.5v1h-0.5zM3,-4.5h0.5v0.5h-0.5zM-2,-4h2v0.5h-2zM-1,-3.5h1v0.5h-1z',
    },
    {
      paint: 'snowCap',
      d: 'M0,-12h1v0.5h-1zM2,-12h0.5v0.5h-0.5zM0,-9.5h1v0.5h-1zM-1.5,-9h3.5v0.5h-3.5zM-2,-8.5h3.5v0.5h-3.5zM-2,-8h2.5v0.5h-2.5zM-2.5,-7.5h1v0.5h-1zM-2.5,-6.5h0.5v0.5h-0.5zM-3,-6h1v0.5h-1zM-3,-5.5h0.5v1h-0.5zM-3,0.5h1.5v0.5h-1.5zM-3,1h2v0.5h-2zM-2,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M1.5,-8.5h0.5v0.5h-0.5zM0.5,-8h1.5v0.5h-1.5zM-1,-7.5h3.5v1h-3.5zM-1,-6.5h4v0.5h-4zM-0.5,-6h3.5v0.5h-3.5zM-0.5,-5.5h4v1h-4zM0,-4.5h2.5v0.5h-2.5zM0,-4h1.5v0.5h-1.5zM0,-3.5h0.5v0.5h-0.5z',
    },
    { paint: 'bareBranch', d: 'M1,-12.5h1v0.5h-1zM0,-11.5h2.5v0.5h-2.5zM1,-11h1v1.5h-1z' },
    { paint: 'firewoodLog', d: 'M-2,-2.5h1v0.5h-1zM-2,-1.5h1v2h-1zM-1.5,0.5h0.5v0.5h-0.5z' },
    {
      paint: 'lanternGlow',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-2,-5h1v1h-1zM2,-3h0.5v2h-0.5zM1,-2.5h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM0.5,-2h1v1h-1zM0.5,-1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 254,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'church',
      d: 'M0,-7.5h0.5v0.5h-0.5zM0,-6h0.5v0.5h-0.5zM0,-5.5h1v1h-1zM0,-4.5h0.5v0.5h-0.5zM0,-4h1v0.5h-1zM-3.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM-3.5,-2.5h3v0.5h-3zM0,-2.5h1v3h-1zM-3.5,-2h1v2h-1zM-1.5,-2h1v0.5h-1zM-1,-1.5h0.5v3h-0.5zM-3,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M2,-8h0.5v0.5h-0.5zM0.5,-7.5h2v0.5h-2zM0,-7h0.5v1h-0.5zM1,-7h0.5v1h-0.5zM2,-7h0.5v1h-0.5zM0.5,-6h2v0.5h-2zM-3,-5.5h0.5v0.5h-0.5zM1,-5.5h1.5v1h-1.5zM2,-4.5h0.5v0.5h-0.5zM-3.5,-4h0.5v0.5h-0.5zM1,-4h2v4h-2zM-2.5,-3.5h0.5v0.5h-0.5zM-1,-3h1v0.5h-1zM-2.5,-2h0.5v2.5h-0.5zM-0.5,-2h0.5v3.5h-0.5zM-1.5,-1.5h0.5v2h-0.5zM1,0h1.5v0.5h-1.5zM-2,0.5h1v0.5h-1zM0.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M0.5,-6.5h0.5v0.5h-0.5zM-3,-3.5h0.5v0.5h-0.5zM-2,-3h1v0.5h-1zM-0.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M1,-11.5h0.5v0.5h-0.5zM0.5,-11h0.5v1h-0.5zM0,-10h1.5v1h-1.5zM-0.5,-9h2v1h-2zM0.5,-8h0.5v0.5h-0.5zM-2,-7h0.5v0.5h-0.5zM-2,-6.5h2v0.5h-2zM-2.5,-6h2.5v1h-2.5zM-3,-5h3v0.5h-3zM2.5,-5h0.5v0.5h-0.5zM-3.5,-4.5h3.5v0.5h-3.5zM0.5,-4.5h1.5v0.5h-1.5zM-3,-4h3v0.5h-3zM-2,-3.5h2v0.5h-2zM-3,0.5h1v0.5h-1zM-3,1h2v0.5h-2z',
    },
    {
      paint: 'ice',
      d: 'M1,-11h0.5v0.5h-0.5zM1,-10.5h1v0.5h-1zM1.5,-10h1v1h-1zM1.5,-9h1.5v1h-1.5zM0,-8h0.5v0.5h-0.5zM1,-8h1v0.5h-1z',
    },
    { paint: 'firewoodLog', d: 'M0.5,-7h0.5v0.5h-0.5zM1.5,-7h0.5v1h-0.5zM-2,-2h0.5v2.5h-0.5z' },
    { paint: 'lanternGlow', d: 'M0,-3.5h1v1h-1z' },
  ],
  pixels: 230,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant0];
